"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FromUndergroundTime = FromUndergroundTime;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _UndergroundInfo = require("../../../../types/UndergroundInfo");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function FromUndergroundTime(_ref) {
  let {
    transportType,
    timeTo
  } = _ref;
  const Icon = transportType === _UndergroundInfo.ETransportType.Walk ? _uiKit.IconWalk16 : _uiKit.IconCar16;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['distance'],
    "data-testid": "from_underground_time"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon']
  }, /*#__PURE__*/React.createElement(Icon, {
    "data-testid": `from_underground_time_icon_${transportType}`,
    color: 'gray_icons_100'
  })), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: 'gray60_100'
  }, `${timeTo}.`));
}